<template>
    <el-card shadow="never" class='card echarts-box'>
      <h4>活动数据</h4>
        <div class="tab_box">
          <div :class="['item', 'item'+ index]" v-for="(item, index) in tabList" :key="item.code">
            <el-tooltip effect="light" placement="right">
              <div slot="content" v-html="getXssIntro(item.tip)"></div>
              <span class="title">{{item.name}} <i class="el-icon-question"></i></span>
            </el-tooltip>
            <p class="data">{{pullNewTotal}}</p>
          </div>
        </div>
        <div v-if="chartData && chartData.length" id="chart" v-loading="loading"></div>
        <NoData v-else errTitle="暂无数据" setHeight="500px" v-loading="loading"></NoData>
    </el-card>
</template>
<script>
import echarts from 'echarts'
import moment from 'moment'
import { mapGetters } from 'vuex'
import NoData from "@/components/base/no-data"
import { getMemberData, getMemberTrend } from "@/api/vipMarket";
import { getXssIntro } from '@/utils/xss'
export default {
  components: { NoData },
  computed: { ...mapGetters(['userInfo']) },
  data() {
    return {
      loading: false,
      tabList: [
        {
          name: '拉新人数',
          code: 'pullNewTotal',
          tip: '累计拉新人数：</br>活动期间，油站累计拉新人数，不包含退款的新用户'
        }
      ],
      result: {},
      colorList: ['#FFAC52', '#3377FF'],
      tiemType: 0,
      pullNewTotal:0,
      dataTime: [],
      chartData:[],
      myChart: null
    }
  },
  mounted () {
    let _this = this;
    window.onresize = function() {
        _this.myChart.resize()
    }
  },
  methods: {
    getXssIntro,
    init (params) {
      console.log(params)
      const{ items, pullNewTotal } = params
      this.chartData = items
      this.pullNewTotal = pullNewTotal
      this.$nextTick(()=> this.drawChart())
    },
    timeTypeChange (val) {
      let startTime = ''
      let endTime = moment().subtract(1, 'days').format('YYYY-MM-DD')
      if (val === 0){
        startTime = moment().subtract(30, 'days').format('YYYY-MM-DD')
      } else if (val === 1) {
        startTime = moment().subtract(90, 'days').format('YYYY-MM-DD')
      } else if (val == 2) {
        startTime = moment().subtract(182, 'days').format('YYYY-MM-DD')
      } else {
        startTime = this.dataTime[0]
        endTime = this.dataTime[1]
      }
      this.dataTime = [startTime, endTime]
      let param = {
        gasId: this.userInfo.gasId,
        beginDate: startTime,
        endDate: endTime
      }
      this.getMemberTrend(param)

    },
    formTimeChange (val) {
      if (val) {
        this.tiemType = -1
      } else {
        this.tiemType = 0
      }
      this.timeTypeChange (this.tiemType)
    },
    drawChart(){
      if (!this.chartData.length) return
      this.myChart = null
      let timeDate = this.chartData.map(item => {
        if(item.time.split(' ').length !== 1) {
          return item.time.split(' ')[1]
        } else {
        return item.time
        }
      })
      let countNum = this.chartData.map(item => item.totalNum)
      let dayNum = this.chartData.map(item => item.num)
      let countNumShow = this.chartData.map(item => item.totalNum || 0)
      let dayNumShow = this.chartData.map(item => item.num || 0)
      let option = {
        color: this.colorList,
        grid: {
          left: '3%',
          right: '4%',
          bottom: '40',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#fff',
          axisPointer: {
            type: 'cross',
            lineStyle: {
              type: 'dashed'
            },
            label: {
              backgroundColor: '#6a7985'
            }
          },
          textStyle: {
            color: '#606266'
          },
          formatter: (param) => {
            let html = `<p style="margin: 0 0 12px 0"><b>${param[0].name}</b></p>`
            param.forEach(item => {
              if(item.seriesName === '新增拉新人数'){
                html+=`
                  <span style="display:inline-block;width:12px;height:12px;background:${item.color};margin-right:5px"></span>
                  <span>${item.seriesName}：${dayNum[item.dataIndex] === null ? '-' : item.data}人</span></br>
                `
              } else {
                html+=`
                  <span style="display:inline-block;width:10px;height:10px;border-radius:5px;border:2px solid ${item.color};margin-right:5px"></span>
                  <span>${item.seriesName}：${countNum[item.dataIndex] === null ? '-' : item.data}人</span></br>
                `
              }
            })
            return html
          },
          padding: [10,16],
          extraCssText: 'box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1)'
        },
        legend: [
          {
            data: ['新增拉新人数'],
            right: '15%',
            itemHeight: 12,
            itemWidth: 12
          },
          {
            data: ['累计拉新人数'],
            right: '4%'
          }
        ],
        xAxis: [
          {
            type: 'category',
            data: timeDate,
            nameTextStyle: {
              color:'#666'
            },
            axisLine: {
              lineStyle: {
                color:'#EAEAEA'
              }
            },
            axisLabel: {
              color:'#666'
            },
            axisTick: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            splitLine: {
              lineStyle: {
                type:'dashed',
                color:'#EAEAEA'
              }
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false
            }
          },
          {
            type: 'value',
            splitLine: {
              lineStyle: {
                type:'dashed',
                color:'#EAEAEA'
              }
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '新增拉新人数',
            type: 'bar',
            barMaxWidth: '40',
            data: dayNumShow
          },
          {
            name: '累计拉新人数',
            type: 'line',
            yAxisIndex: 1,
            barMaxWidth: '40',
            data: countNumShow
          }
        ]
      }
      this.myChart = echarts.init(document.getElementById('chart'))
      this.myChart.setOption(option)
    },
    async getMemberData () {
      try {
        const { code, result } = await getMemberData({ gasId: this.userInfo.gasId })
        if (code !== 200) return
        console.log(result)
        this.result = result
      } catch (error) {
        console.log(error)
      }
    },
    async getMemberTrend (param) {
      this.loading = true
      try {
        const { code, result } = await getMemberTrend(param)
        if (code !== 200) return
        this.chartData = result
        this.$nextTick(() => this.drawChart())
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../mixin.less');
  .header{
    margin-bottom: 16px;
    .title{
      color: #333333;
      font-size: 16px;
      font-weight: 600;
    }
    .tip{
      color: #999999;
      font-size: 14px;
      margin-left: 8px;
    }
  }
  .tab_box {
    display: flex;
    margin-bottom: 32px;
    .item{
      width: 272px;
      color: #fff;
      border-radius: 4px; 
      height: 92px;
      padding: 16px;
      margin-right: 16px;
    }
    .data{
      font-size: 24px;
      font-weight: 700;
      line-height: 32px;
      margin-top: 8px;
    }
    .item0{  
      background: linear-gradient(225deg, #81A5FF 0%, #4B7EFE 100%);
    }
    .item1{  
      background: linear-gradient(225deg, #B7C5DC 0%, #8394B3 100%);;
    }
    .title{
      font-size: 14px;
    }
  }
  .el-radio-group{
    margin-right: 10px;
  }
  #chart {
    width: 100%;
    height: 450px;
    margin-top: 20px;
  }
</style>